var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatpump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#96bf72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.34,72.62c.33,0,.61-.27.61-.61v-4.35c0-.33-.27-.61-.61-.61h-5.57v-2.91c0-.33-.27-.61-.61-.61h-5.5v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-4.89v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-4.89v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-4.89v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-4.89v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-4.89v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-4.89v-.76c0-.33-.27-.61-.61-.61s-.61.27-.61.61v.76h-5.51c-.33,0-.61.27-.61.61v20.27c0,.33.27.61.61.61h5.51v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h4.89v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h4.89v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h4.89v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h4.89v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h4.89v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h4.89v.76c0,.33.27.61.61.61s.61-.27.61-.61v-.76h5.5c.33,0,.61-.27.61-.61v-2.91h5.57c.33,0,.61-.27.61-.61v-4.35c0-.33-.27-.61-.61-.61h-5.57v-3.33h5.57Zm-.61-4.35v3.14h-4.96v-3.14h4.96Zm-53.82,15.54v-19.06h4.91v19.06h-4.91Zm6.12,0v-19.06h4.89v19.06h-4.89Zm6.11,0v-19.06h4.89v19.06h-4.89Zm6.11,0v-19.06h4.89v19.06h-4.89Zm6.11,0v-19.06h4.89v19.06h-4.89Zm6.11,0v-19.06h4.89v19.06h-4.89Zm6.11,0v-19.06h4.89v19.06h-4.89Zm11,0h-4.89v-19.06h4.89v19.06Zm6.17-6.65v3.14h-4.96v-3.14h4.96Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.23,41.51h7.78v7.15c0,3.63-2.95,6.58-6.58,6.58-.33,0-.61.27-.61.61s.27.61.61.61c4.3,0,7.8-3.5,7.8-7.8v-7.76c0-.33-.27-.61-.61-.61h-6.39l17.52-11.7,17.52,11.7h-6.39c-.33,0-.61.27-.61.61v7.76c0,4.3,3.5,7.8,7.8,7.8.33,0,.61-.27.61-.61s-.27-.61-.61-.61c-3.63,0-6.58-2.95-6.58-6.58v-7.15h7.78c.27,0,.5-.17.58-.43.08-.26-.02-.53-.24-.68l-19.51-13.04c-.2-.14-.47-.14-.67,0l-19.51,13.04c-.22.15-.32.42-.24.68.08.26.31.43.58.43Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.14,41.14v10.02c0,.33.27.61.61.61s.61-.27.61-.61v-10.02c0-.33-.27-.61-.61-.61s-.61.27-.61.61Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatpump);
export default __webpack_public_path__ + "static/media/heatpump.d3abc32ad12325d307fc15e47cb98edf.svg";
export { ForwardRef as ReactComponent };